import KeycardsContainer from './keycards-container';

export default KeycardsContainer;
